import { useStoreContacts } from '@/entities/contact'
import { useStoreRooms } from '@/entities/room'


import { useRoomPublicIdentityStore } from '@/shared/store/public-identity'
import { Room } from '@/shared/types/store'
import { unknownContact } from '@/shared/utils/contact'
import { createPrivateRoom } from '@/shared/utils/im'
import { fromPServedUser, numberToUri } from '@/shared/utils/uri'

export const getOrCreateRoomForSession = (number: string, name?: string): Room => {
  const storeRooms = useStoreRooms()
  const storeContacts = useStoreContacts()
  const { getPServedByIdentity } = useRoomPublicIdentityStore()

  let numberToFind = number
  const pServed = getPServedByIdentity(number)
  if (pServed) {
    numberToFind = fromPServedUser(pServed)
  }

  let room = Array.from(storeRooms.rooms.values()).find(x => x.number === numberToFind)

  if (!room) {
    const contact = storeContacts.findByInternalNumber(numberToFind) || unknownContact(numberToFind, name ?? number)
    const imLogin = contact.imLogin || numberToUri(contact.internalNumber)
    room = createPrivateRoom(imLogin, contact)
  } else if (room.name === numberToFind && name) {
    room.name = name
  }

  return room
}
